<div class="bg-white">
  <div class="bg-e-white md:py-[50px] rounded-xl">

    <div class="container-default grid grid-cols-1 md:grid-cols-[33%,_1fr] md:gap-6 px-6">

      <div class="flex flex-col items-start justify-center min-h-[375px]">
        <h1 class="hyphens-auto mt-6" itemprop="name">{{_recipe?.displayname}} <span class="block text-sm md:text-lg md:font-medium font-sans">{{_recipe?.subtitle}}</span></h1>

        <rating entitytype="RECIPE" class="hidden flex-col lg:flex" [entityid]="_recipe?.id"></rating>

        <div class="flex flex-row flex-wrap my-4 gap-2">
          <app-chip>
            <time class="text-sm">{{_recipe?.cookingtime}} {{'common.minutes_abbr' | translate}}</time>
          </app-chip>
          @if (getCalories(_recipe)) {
          <app-chip>
            <span class="text-sm">{{getCalories(_recipe)}} {{'unit_abbr.KILOCALORIES' | translate}}</span>
          </app-chip>
          }
          <app-chip>
            <span class="text-sm">{{_recipe?.vegetableweight }} {{'unit_abbr.GRAM' |translate}} {{'recipe.vegetableweight'| translate}}</span>
            <!--<span class="text-sm">{{'recipe.difficulty-' + _recipe?.difficulty |translate}}</span>-->
          </app-chip>
        </div>
        <p class="font-serif font-semibold lg:hidden">{{_recipe?.intro}}</p>
      </div>
      <div class="order-first md:order-last ">
        <app-image alt="{{_recipe?.displayname}}" class="rounded-3xl object-cover w-full" [size]="isMobile ? 'md' : 'lg'" [imageobject]="_recipe"></app-image>
      </div>
    </div>
    <div class="container-default mt-6 px-6 flex-row h-10 hidden md:flex">
      @if(getRecipecardUrl()){
      <a href="{{getRecipecardUrl()}}" target="_blank" rel="nofollow" class="my-auto border border-e-dark-green py-1 px-2 rounded-lg hover:bg-e-dark-green hover:text-white">
        <i class="bi bi-printer"></i> {{'common.print' |translate}}
      </a>
      }
      @if (!popup) {
      <div (click)="scrollToMain()" class="w-[39px] h-[39px] icon-round mx-auto cursor-pointer ">
        <img alt="arrow down" class="h-5 w-5" height="20" width="20" src="./assets/images/icons/arrow_down.svg" />
      </div>
      }
    </div>
  </div>

  <!-- INGREDIENTS -->
  <div class="bg-e-white rounded-xl m-6 p-6 flex flex-col lg:hidden min-h-[700px]">
    <h2>{{'recipe.ingredients' | translate}}</h2>
    <app-ingredientlist class="my-6" [doublepersons]="_recipe?.doublepersons" [personquantity]="personquantity" [ingredients]="_recipe?.ingredients"></app-ingredientlist>
  </div>

  <div class="container-default flex flex-col md:flex-row" id="main" [ngClass]="popup ? ' md:mt-[75px]' : 'md:mt-[100px]'">
    <div class="w-full md:w-3/5 md:ml-6">
      <!-- PREPARATION -->
      <div class="flex flex-col bg-white">
        <p class="font-serif font-semibold mb-[30px] hidden lg:flex">{{_recipe?.intro}}</p>

        <div class="flex md:flex-row flex-wrap-reverse justify-between gap-3">
          <h2 class="whitespace-nowrap">{{'recipe.preparations'| translate}} ({{_recipe?.cookingtime}} {{'common.minutes_abbr' | translate}})</h2>
          <app-wakelock class="my-auto"></app-wakelock>
        </div>
        <div><small>{{'recipe.click a line to cross off' | translate}}</small></div>
        <ol class="counter">
          @for (preparation of _recipe?.preparations; track $index) {
          <li class="counter-item" (click)="toggleDonePreparation(preparation.sequenceid)">
            <span [ngClass]="{'line-through': donePreparations.indexOf(preparation.sequenceid) >=0 }">{{preparation.description}}</span>
          </li>
          }
        </ol>
      </div>

      <!-- TIP -->
      <div class="md:mx-auto flex items-center bg-e-white rounded-lg p-5 my-6 md:m-6">
        <div class="flex shrink-0 justify-center items-center bg-e-orange rounded-full text-white font-serif text-base h-[50px] w-[50px] mr-6">
          TIP
        </div>
        <span>{{_recipe?.garnertip}}</span>
      </div>
      @if (youtubeUrl || vimeoUrl) {
      <div class="flex flex-col gap-2" id="video">
        @if (youtubeUrl) {
        <iframe width="640" height="360" [src]="youtubeUrl" title="YouTube video player" frameborder="0" class="mx-auto rounded-lg max-w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen></iframe>
        }
        @if(vimeoUrl){
        <iframe title="vimeo-player" [src]="vimeoUrl" width="640" height="360" class="mx-auto rounded-lg max-w-full" frameborder="0" referrerpolicy="strict-origin-when-cross-origin"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowfullscreen></iframe>
        }
      </div>
      }

      <rating class="flex flex-col lg:hidden" entitytype="RECIPE" [entityid]="_recipe?.id"></rating>

    </div>

    <div class="w-full md:w-2/5 md:ml-[100px]">
      <div class="bg-e-white rounded-xl m-6 p-6 hidden flex-col lg:flex">
        <h2>{{'recipe.ingredients' | translate}}</h2>
        <app-ingredientlist class="my-6" [doublepersons]="_recipe?.doublepersons" [personquantity]="personquantity" [ingredients]="_recipe?.ingredients"></app-ingredientlist>
      </div>
      <!-- VITASCORE -->
      <div class="container-default flex flex-col bg-e-light-green my-6 md:m-6 px-5 pt-6 rounded-lg">
        <h3 class="text-2xl">{{'score.nice_impact' |translate}}</h3>
        <app-vitascores [recipe]="_recipe"></app-vitascores>
      </div>

      <!-- LIFESTYLES -->
      @if (_recipe?.lifestyles && _recipe?.lifestyles.length > 0) {
      <div class="flex bg-e-white rounded-lg flex-wrap p-3 my-6 md:m-6">
        @for (lifestyle of _recipe?.lifestyles; track $index; let last = $last) {
        <span class="text-sm font-medium leading-5 whitespace-wrap">{{getLifestyle(lifestyle.lifestyleid)?.name|
          capitalizefirst}}@if (!last) {,&nbsp;}</span>
        }
      </div>
      }

      <!-- FOOD VALUES -->
      <div class="flex flex-col bg-e-white rounded-lg p-5 my-6 md:m-6">
        <div class="flex flex-row flex-grow flex-wrap justify-between">
          <h3 class="text-2xl">{{ 'nutrient.nutritional values' | translate }}</h3><small>{{'recipe.per portion'| translate}}</small>
        </div>

        @for (nutrient of _recipe?.nutrients; track $index) {
        <div class="flex flex-row justify-between border-b border-black mt-[5px] pb-[5px]">
          <span>{{'nutrient.' + nutrient.name | translate}}</span> <span>{{nutrient.quantity  | number:'1.0-0' }} {{'unit_abbr.' + nutrient.unit |translate}}</span>
        </div>
        }

        <div class="mt-5">
          <span>{{ 'allergen.allergen information' | translate }}</span>
          <div class="flex flex-row flex-wrap mt-2 gap-2">
            @for (allergen of _recipe?.allergens; track $index) {
            <app-chip> <span class="text-sm font-medium">{{'allergen.' + allergen.name | translate}}</span> </app-chip>
            }
          </div>
        </div>

        <div class="mt-6">
          @if (getScore('NUTRISCORE')?.scorerating && getScore('NUTRISCORE')?.scorerating !== '0') {
          <img width="120px" height="65px" alt="nutriscore-{{getScore('NUTRISCORE')?.scorerating}}" loading="lazy"
            src="assets/images/nutriscore/nutri-score-{{getScore('NUTRISCORE')?.scorerating.toLowerCase()}}.svg" />
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- template for the bottom drawer dialog -->
<ng-template #bottomdrawer>
  <div class="flex flex-row justify-center p-[15px] rounded-lg bg-white min-w-[300px]">
    <a routerLink="/recipefirst" class="button-base rounded-full w-full md:w-[250px]" id="chooselifestyle">
      <span>{{'common.order_now' | translate}}</span>
    </a>
  </div>
</ng-template>
